module.exports = __webpack_public_path__ + "img/Galon.105a94a5.jpg";